import React from "react";
import { FaQuoteLeft, FaQuoteRight } from "react-icons/fa";
import "../App.css";

const testimonials = [
  {
    id: 1,
    text: "I have had the pleasure to work with Noreen for the branding and web development services for my clothing brand. Noreen's thorough professionalism and dedication is unmatched. I have had conversations with several international marketing companies, however, settling with WHYME Solutions for my business is one of the best decisions I have ever made. It was extremely important for me to work with someone who not only listens but also understands my vision. Noureen took my social media presence to another level and created a spectacular website for me which reflects my brand image perfectly. I highly recommend WHYME Solutions to anyone who is seeking digital services and brand development. ",
    name: "Ayesha Ali From US",
    position: "Founder | CEO",
  },
  {
    id: 2,
    text: "Partnering with WHYME Solutions for my brand, digital marketing as truly been a game-changer. Noreen’s expertise and strategic insights have been remarkable. Her Professionalism and dedication are unparalleled. she guided me through each step with an aligned vision and detailed plan to help my brand break into the Australian market. Her strategies and proactive approach have made this partnership one of the smartest moves I’ve made. Highly recommended!",
    name: "Mariyam Adam from Australia",
    position: "CEO",
  },
  {
    id: 3,
    text: "Signing a contract with WHYME Solutions to manage requirements and train my staff has been an exceptional experience. Working in the Canadian market with a remote team based in Pakistan, WHYME has been a strong, reliable bridge that connects us seamlessly. This is my first time hiring a fully remote team for my new project, and I’m happy and satisfied with the outcome. WHYME’s expertise and use of new technology have made this setup efficient and effective, far exceeding my expectations. Highly recommended for anyone seeking professional, reliable remote solutions.",
    name: "Ethan Smith from Canada",
    position: "HR Director",
  },
  {
    id: 4,
    text: "Working with WHYME Solutions for our financial management has been an exceptional experience. Their team, providing us with tailored strategies that streamlined our budgeting, forecasting, and cash flow management. WHYME’s commitment to detail and proactive approach allowed us to identify opportunities we hadn’t considered, ultimately enhancing our profitability. The transparency and dedication they bring to every interaction make it clear that client success is their top priority. I highly recommend WHYME Solutions for any business looking to achieve financial clarity and growth—they truly elevate financial services to a whole new level!",
    name: "Umair Akhter from Pakistan",
    position: "Founder | CFO",
  },
  {
    id: 5,
    text: "WHYME Solutions has been a game-changer for our e-commerce business in the UK. Their professionalism in managing social media and performance marketing is unmatched, utilizing data-driven strategies tailored to our market needs. Their focused approach has amplified our online presence and engagement, delivering measurable results that are driving real growth. For any e-commerce brand looking to excel in digital success, WHYME is the ideal partner.",
    name: "Henry Sinclair from UK",
    position: "Founder | CEO",
  },
];

const Testimonials = () => {
  return (
    <section className="py-16 bg-white relative">
      <div className="container mx-auto px-4">
        <h1 className="text-4xl font-bold text-center mb-12 text-[#13689b]">
          What Our Clients Say
        </h1>
        <div className="relative flex overflow-x-auto space-x-8 py-6 snap-x snap-mandatory scrollbar-hide">
          {testimonials.map((testimonial) => (
            <div
              key={testimonial.id}
              className="snap-center flex-shrink-0 max-w-[350px] bg-white shadow-lg rounded-xl p-8 relative transition-transform duration-300 hover:scale-105"
            >
              {/* Decorative Gradient */}
              <div className="absolute inset-0 bg-gradient-to-br from-[#13689b] via-blue-400 to-blue-200 opacity-10 rounded-xl pointer-events-none"></div>

              {/* Content */}
              <div className="flex flex-col items-start mb-4">
                <p className="font-bold text-lg text-[#13689b]">{testimonial.name}</p>
                <p className="text-sm text-gray-500">{testimonial.position}</p>
              </div>
              <div className="relative text-gray-700 italic">
                <FaQuoteLeft className="absolute -top-4 -left-4 text-4xl text-blue-200" />
                <p className="pl-6 pr-2 text-gray-800">{testimonial.text}</p>
                <FaQuoteRight className="absolute -bottom-4 -right-6 text-4xl text-blue-200" />
              </div>
            </div>
          ))}
        </div>
      </div>
      {/* Decorative Blobs */}
      <div className="absolute top-[-50px] left-[-100px] w-[200px] h-[200px] bg-blue-300 opacity-30 rounded-full blur-3xl"></div>
      <div className="absolute bottom-[-50px] right-[-100px] w-[250px] h-[250px] bg-blue-500 opacity-30 rounded-full blur-3xl"></div>
    </section>
  );
};

export default Testimonials;
